<template>
  
  <!-- slider -->
  <section>
    <div class="hidden w-full pt-20 mx-auto md:block">
      <div id="carouselExampleCaptions" class="relative carousel slide" data-bs-ride="carousel">
        <!-- Original carousel indicators commented out; showing single flood-relief indicator only -->
        <!--
        <div class="absolute bottom-0 left-0 right-0 flex justify-center p-0 mb-4 carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="3"
            aria-label="Slide 4"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="4"
            aria-label="Slide 5"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="5"
            aria-label="Slide 6"
          ></button>
        </div>
        -->
        <div class="absolute bottom-0 left-0 right-0 flex justify-center p-0 mb-4 carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Flood Relief Banner"
          ></button>
        </div>
        <!-- Original carousel slides removed from view; preserved below without nested comments -->
        <!-- ORIGINAL_SLIDES_START
        <div class="w-full overflow-hidden carousel-inner">
          <div class="float-left w-full carousel-item active">
            <a href="https://www.facebook.com/cuci.pbf/posts/pfbid0DaTiKWQQ5B35F8cYM5X9orz5pmkuLLFWkaR16Qhvry5BqgZkpfoxCqDuWP4JNPXvl?rdid=Ky23p2qa8EypauSw#" target="_blank">
              <img src="@/assets/img/cuci_banner_2025.png" class="block w-full" alt="..." />
            </a>
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">บริจาค</h5>
              <p>open pbb 2025</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <a href="https://www.facebook.com/cuci.pbf/posts/pfbid037EK3wsPogA39S9b4VG1oNfvyeC16wX3nZ15AFu6USSGnrrnXD3t7h1uimhJPiappl?rdid=sRmYucASnXEblXXI">
              <img src="@/assets/img/cuci_banner_2025_2.png" class="block w-full" alt="..." />
            </a>
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">CUCI</h5>
              <p>CUCI Academy</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <img src="@/assets/img/bg.png" class="block w-full" alt="..." />
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">CUCI</h5>
              <p>สร้างสรรค์สังคมที่ดีกว่าร่วมกัน</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <img src="@/assets/img/riba_ban.png" class="block w-full" alt="..." />
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">สะสางดอกเบี้ย</h5>
              <p>ทางเลือกเพื่อความสะอาดใจ</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <img src="@/assets/img/derma_bg.png" class="block w-full" alt="..." />
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">บริจาค</h5>
              <p>มอบโอกาสสู่การร่วมกันพํฒนาและสร้างสรรค์สังคมที่ดีกว่าไปร่วมกัน</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <img src="@/assets/img/flood_relief_banner_2025.jpg" class="block w-full" alt="Flood Relief Mission Banner" />
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">Misi Bantu Banjir 2025</h5>
              <p>สนับสนุนค่าเชื้อเพลิงให้ผู้ประสบภัยน้ำท่วม</p>
            </div>
          </div>
        </div>
        ORIGINAL_SLIDES_END -->
        <div class="w-full overflow-hidden carousel-inner">
          <div class="float-left w-full carousel-item active">
            <router-link
              :to="{ name: 'Home' }"
              target="_blank">
              <img
                src="@/assets/img/bg.png"
                class="block w-full"
                alt="Flood Relief Mission Banner"
              />
            </router-link>
            <!-- <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">Misi Bantu Banjir 2025</h5>
              <p>สนับสนุนค่าเชื้อเพลิงให้ผู้ประสบภัยน้ำท่วม</p>
            </div> -->
          </div>
        </div>
        <button
          class="absolute top-0 bottom-0 left-0 flex items-center justify-center p-0 text-center border-0 carousel-control-prev hover:outline-none hover:no-underline focus:outline-none focus:no-underline"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span class="inline-block bg-no-repeat carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center p-0 text-center border-0 carousel-control-next hover:outline-none hover:no-underline focus:outline-none focus:no-underline"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span class="inline-block bg-no-repeat carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
    <div class="w-full pt-20 mx-auto md:hidden lg:hidden xl:hidden">
      <div id="carouselExampleCaptionsMobile" class="relative carousel slide" data-bs-ride="carousel">
        <!-- Original mobile indicators commented out; showing single flood-relief indicator only -->
        <!-- ORIGINAL_MOBILE_INDICATORS_START
        <div class="absolute bottom-0 left-0 right-0 flex justify-center p-0 mb-4 carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleCaptionsMobile" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleCaptionsMobile" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleCaptionsMobile" data-bs-slide-to="2" aria-label="Slide 3"></button>
          <button type="button" data-bs-target="#carouselExampleCaptionsMobile" data-bs-slide-to="3" aria-label="Slide 4"></button>
          <button type="button" data-bs-target="#carouselExampleCaptionsMobile" data-bs-slide-to="4" aria-label="Slide 5"></button>
          <button type="button" data-bs-target="#carouselExampleCaptionsMobile" data-bs-slide-to="5" aria-label="Slide 6"></button>
        </div>
        ORIGINAL_MOBILE_INDICATORS_END -->
        <div class="absolute bottom-0 left-0 right-0 flex justify-center p-0 mb-4 carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleCaptionsMobile"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Flood Relief Banner"
          ></button>
        </div>
        <!-- ORIGINAL_MOBILE_SLIDES_START
        <div class="w-full overflow-hidden carousel-inner">
          <div class="float-left w-full carousel-item active">
            <a href="https://www.facebook.com/cuci.pbf/posts/pfbid0DaTiKWQQ5B35F8cYM5X9orz5pmkuLLFWkaR16Qhvry5BqgZkpfoxCqDuWP4JNPXvl?rdid=Ky23p2qa8EypauSw#" target="_blank">
              <img src="@/assets/img/cuci_banner_2025.png" class="block w-full" alt="..." />
            </a>
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">บริจาค</h5>
              <p>open pbb 2024</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <a href="https://www.facebook.com/cuci.pbf/posts/pfbid037EK3wsPogA39S9b4VG1oNfvyeC16wX3nZ15AFu6USSGnrrnXD3t7h1uimhJPiappl?rdid=sRmYucASnXEblXXI">
              <img src="@/assets/img/cuci_banner_2025_2.png" class="block w-full" alt="..." />
            </a>
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">CUCI</h5>
              <p>CUCI Academy</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <img src="@/assets/img/bg.png" class="block w-full" alt="..." />
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">CUCI</h5>
              <p>สร้างสรรค์สังคมที่ดีกว่าร่วมกัน</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <img src="@/assets/img/riba_ban.png" class="block w-full" alt="..." />
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">สะสางดอกเบี้ย</h5>
              <p>ทางเลือกเพื่อความสะอาดใจ</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <img src="@/assets/img/derma_bg.png" class="block w-full" alt="..." />
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">บริจาค</h5>
              <p>มอบโอกาสสู่การร่วมกันพํฒนาและสร้างสรรค์สังคมที่ดีกว่าไปร่วมกัน</p>
            </div>
          </div>
          <div class="float-left w-full carousel-item">
            <img src="@/assets/img/flood_relief_banner_2025.jpg" class="block w-full" alt="Flood Relief Mission Banner" />
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">Misi Bantu Banjir 2025</h5>
              <p>สนับสนุนค่าเชื้อเพลิงให้ผู้ประสบภัยน้ำท่วม</p>
            </div>
          </div>
        </div>
        ORIGINAL_MOBILE_SLIDES_END -->
        <div class="w-full overflow-hidden carousel-inner">
          <div class="float-left w-full carousel-item active">
            <router-link
              :to="{ name: 'Home' }"
              target="_blank">
              <img
                src="@/assets/img/bg.png"
                class="block w-full"
                alt="Flood Relief Mission Banner"
              />
            </router-link>
            <div class="absolute hidden text-center carousel-caption md:block">
              <h5 class="text-xl">Misi Bantu Banjir 2025</h5>
              <p>สนับสนุนค่าเชื้อเพลิงให้ผู้ประสบภัยน้ำท่วม</p>
            </div>
          </div>
        </div>
        <button
          class="absolute top-0 bottom-0 left-0 flex items-center justify-center p-0 text-center border-0 carousel-control-prev hover:outline-none hover:no-underline focus:outline-none focus:no-underline"
          type="button"
          data-bs-target="#carouselExampleCaptionsMobile"
          data-bs-slide="prev"
        >
          <span class="inline-block bg-no-repeat carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center p-0 text-center border-0 carousel-control-next hover:outline-none hover:no-underline focus:outline-none focus:no-underline"
          type="button"
          data-bs-target="#carouselExampleCaptionsMobile"
          data-bs-slide="next"
        >
          <span class="inline-block bg-no-repeat carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </section>
  <!-- \.slider -->

  <!-- // โครงการที่ผ่านมา -->
  <section class="bgcc">
    <div class="container pb-5 mx-auto text-center">
      <div class="w-full px-4 pt-2 mb-4 lg:mx-auto lg:w-1/2">
        <h2
          class="mb-2 text-2xl md:text-4xl font-semibold leading-tight text-gray-800 capitalize pt-6 lg:pt-10 "
        > บริการของเรา
        </h2>
      </div>
      <div class="flex flex-wrap items-center mb-4">
        
        <div class="w-full p-4 lg:w-4/12 sm:w-12/12">
          <router-link
            to="/riba"
            class="block text-left"
          >
            <img
              src="@/assets/img/riba_2.png"
              class=""
            />
            
          </router-link>
          </div>
          <div class="w-full p-4 lg:w-4/12 sm:w-12/12">
          <router-link
            to="/crowdfunding"
            class="block text-left"
          >
            <img
              src="@/assets/img/crowdfunding.png"
              class=""
            />
            <!-- <div class="">
              <h5 class="text-base font-semibold text-center text-gray-900">บริจาค</h5>
            </div> -->
          </router-link>
          
        </div>

        <div class="w-full p-4 lg:w-4/12 sm:w-12/12">
          <router-link to="/ezakat"
            class="block text-left"
          >
            <img
              src="@/assets/img/tabong_zakat.png"
              class=""
            />
            <!-- <div class="">
              <h5 class="text-base font-semibold text-center text-gray-900"><center>สะสางดอกเบี้ย</center></h5>
            </div> -->
          </router-link>
          </div>
        
        
      </div>
      <!-- <a href="#" class="inline-block px-6 py-2 text-white bg-green-600 border-2 border-green-600 rounded-md hover:text-green-600 hover:bg-green-200">ดูทั้งหมด</a> -->

    </div>

  </section>
  <!-- // โครงการที่กำลังดำเนินการ -->

  <!-- สะสางดอกเบี้ย -->
  <section class="bgcc">
    <div class="container py-1 mx-auto">
      <div class="flex flex-wrap items-center ">
        <div class="order-last w-full p-4 lg:w-full lg:order-first">
          <!-- Crowdfunding Banner -->
          <div class="mb-8">
            <router-link to="/crowdfunding" class="block overflow-hidden transition-all duration-300 rounded-xl shadow-lg hover:shadow-xl hover:scale-[1.01]">
              <div class="relative">
                <!-- Mobile: แสดงรูปขนาดเล็ก -->
                <img
                  src="@/assets/img/mini-crowdfunding.jpeg"
                  alt="โครงการอาหารกลางวันเพื่อนักเรียนฟากีรมิสกีน"
                  class="block w-full h-auto object-cover md:hidden"
                />
                <!-- Desktop: แสดงรูปขนาดเต็ม -->
                <img
                  src="@/assets/img/crowdfunding.jpeg"
                  alt="โครงการอาหารกลางวันเพื่อนักเรียนฟากีรมิสกีน"
                  class="hidden w-full h-auto object-cover md:block"
                />
              </div>
            </router-link>
          </div>

          <!-- <h2 class="my-6 text-2xl font-semibold text-gray-700 dark:text-gray-200">ข้อมูลการสะสางดอกเบี้ย</h2> -->
    
          <!-- Card จำนวนวัน-->
        <div class="grid gap-6 mb-8 md:grid-cols-2 xl:grid-cols-3">
            <!-- <div class="flex items-center p-4 bg-orange-500 rounded-lg shadow-xs dark:bg-orange-800">
              <div class="p-3 mr-4 text-orange-500 bg-orange-100 rounded-full dark:text-orange-100">
                <i class="fa-solid fa-calendar-days"></i>      
              </div>
              <div>
                <p class="mb-2 text-sm font-medium text-white dark:text-gray-400">เริ่มรับสะสางดอกเบี้ยตั้งแต่ 30 มิถุนายน 2562 </p>
                <p class="text-lg font-semibold text-white dark:text-gray-200">จำนวนวันสะสม 2,222 วัน</p>
            </div>
          </div> -->
          <!-- Card ครั้งที่โอน-->
          <!-- <div class="flex items-center p-4 bg-orange-500 rounded-lg shadow-xs dark:bg-orange-800">
            <div class="p-3 mr-4 text-orange-500 bg-orange-100 rounded-full dark:text-orange-100">
              <i class="fa-solid fa-money-bill-transfer"></i>   
            </div>
            <div>
                <p class="mb-2 text-sm font-medium text-white dark:text-gray-400">จำนวนการสะสางสะสม</p>
                <p class="text-lg font-semibold text-white dark:text-gray-200">96,541 ครั้ง</p>
            </div>
          </div>       -->
          <!-- Card จำนวนเงิน-->
          <!-- <div class="flex items-center p-4 bg-orange-500 rounded-lg shadow-xs dark:bg-orange-800">
            <div class="p-3 mr-4 text-orange-500 bg-orange-100 rounded-full dark:text-orange-100">
              <i class="fa-solid fa-sack-dollar"></i>
            </div>
            <div>
                <p class="mb-2 text-sm font-medium text-white dark:text-gray-400">จำนวนเงิน </p>
                <p class="text-lg font-semibold text-white dark:text-gray-200"> 5,948,239.24 บาท</p>
            </div>
          </div>             -->
    </div>
    <!-- <h2 class="my-6 text-2xl font-semibold text-gray-700 dark:text-gray-200">
        ข้อมูลโครงการสาธารณประโยชน์
    </h2> -->
    <div class="grid gap-6 mb-8 md:grid-cols-2 xl:grid-cols-4">
          <!-- Card โครงการที่อนุมัติ-->
          <!-- <div class="flex items-center p-4 bg-orange-500 rounded-lg shadow-xs dark:bg-orange-800">
            <div class="p-3 mr-4 text-orange-500 bg-orange-100 rounded-full dark:text-orange-100">
              
              <i class="fa-solid fa-building"></i>
            </div>
            <div>
                <p class="mb-2 text-sm font-medium text-white dark:text-gray-400">โครงการที่อนุมัติ</p>
                <p class="text-lg font-semibold text-white dark:text-gray-200">45 โครงการ <br />4,235,750 บาท</p>
            </div>
        </div> -->
          <!-- Card โครงการที่ดำเนินการเสร็จแล้ว-->
          <!-- <div class="flex items-center p-4 bg-orange-500 rounded-lg shadow-xs dark:bg-orange-800">
            <div class="p-3 mr-4 text-orange-500 bg-orange-100 rounded-full dark:text-orange-100">
              <i class="fa-solid fa-money-bill-transfer"></i>   
            </div>
            <div>
                <p class="mb-2 text-sm font-medium text-white dark:text-gray-400">โครงการที่ดำเนินการเสร็จแล้ว</p>
                <p class="text-lg font-semibold text-white dark:text-gray-200">37 โครงการ <br />4,044,436 บาท</p>
            </div>
        </div>       -->
          <!-- Card โครงการที่กำลังดำเนินการ-->
          <!-- <div class="flex items-center p-4 bg-orange-500 rounded-lg shadow-xs dark:bg-orange-800">
            <div class="p-3 mr-4 text-orange-500 bg-orange-100 rounded-full dark:text-orange-100">
              <i class="fa-solid fa-money-bill-transfer"></i>   
            </div>
            <div>
                <p class="mb-2 text-sm font-medium text-white dark:text-gray-400">โครงการที่กำลังดำเนินการ</p>
                <p class="text-lg font-semibold text-white dark:text-gray-200">  1 โครงการ <br />200,000 บาท</p>            </div>
        </div>             -->
          <!-- Card จำนวนเงิน-->
          <!-- <div class="flex items-center p-4 bg-orange-500 rounded-lg shadow-xs dark:bg-orange-800">
            <div class="p-3 mr-4 text-orange-500 bg-orange-100 rounded-full dark:text-orange-100">
              <i class="fa-solid fa-money-bill-transfer"></i>   
            </div>
            <div>
                <p class="mb-2 text-sm font-medium text-white dark:text-gray-400">โครงการใหม่เร็วๆ นี้</p>
                <p class="text-lg font-semibold text-white dark:text-gray-200"> 1,261,277.41 บาท</p>            </div>
        </div>           -->
    </div>
        </div>


      </div>
    </div>
  </section>

  <section class="bgcc">
    <center>
        สนับสนุนโดย<br>
        <img style='max-width:200px;' src="@/assets/img/nia.png" alt="Services">
    </center>
        <br>
  </section>

</template>

<script>

export default {
 name: 'Home',
  mounted(){
    window.scrollTo({top: 0, behavior: 'smooth'});
  },
  data(){
      return{
          // url: process.env.VUE_APP_URL,
          // baseURLAPI: process.env.VUE_APP_URL_API,
          // title: process.env.VUE_APP_TITLE
          // <!-- <img src="@/assets/img/bg.png" alt=""> -->
      }
  }

}
</script>
